// extracted by mini-css-extract-plugin
export default {"text":"ua60Yt","seat":"_JnGHy","mobile":"Ysdsn9","selected":"Cx7JoS","seatHover":"fnPngQ","wholeTableReservation":"l0gWhi"};